import { initialOccupationObject } from "../../config/widgets/selectors/availableOccupationsByCountry";
import {CHANGE_LANG, CHANGE_COUNTRY, CHANGE_OCCUPATION, LOGIN, LOGOUT} from "./actionTypes"

export const login = (data) => {
  return {
    type: LOGIN,
    user: data.user,
    error: data.error
  };
};
  
export const logout = () => {
  return {
    type: LOGOUT
  };
};

export const changeLang = (data) => {
  return {
    type: CHANGE_LANG,
    lang: data.lang,
    locale: data.locale,
    flag: data.flag
  }
}

export const changeCountry = (data) => {
  return {
    type: CHANGE_COUNTRY,
    country: data.country,
    occupation: initialOccupationObject,
    displayedOccupations: data.displayedOccupations
  }
}

export const changeOccupation = (data) => {
  return {
    type: CHANGE_OCCUPATION,
    country: data.country,
    occupation: data.occupation,
    displayedOccupations: data.displayedOccupations
  }
}

export const labelOnTopPlugin = {
  id: 'labelOnTop',
  afterDatasetsDraw: (chart) => {
    const { ctx } = chart;
    const meta = chart.getDatasetMeta(0);
    const labels = chart.data.labels;

    ctx.save();
    meta.data.forEach((bar, index) => {
        const label = labels[index];
        const y = bar.y;

        ctx.font = 'normal 13.5px TWKLausanne';
        ctx.fillStyle = '#000';
        ctx.textAlign = 'start';
        ctx.fillText(label, 5, y - 15 );
    });
    ctx.restore();
  }
};

export const tooltipChartJSoptions = {
  displayColors: false,
  bodyFont: {
    size: 18,
    weight: 'bold',
    family: "Atkinson-Hyperlegible-Regular"
  },
  titleFont: {
    size: 16,
    weight: 'normal',
    family: "TWKLausanne"
  },
  align: "center",
  padding: 12
}

export const localizeValue = (value, locale, type = null) => {
  if(typeof value === "undefined"){ 
    return "0"
  }else{ 
    if(type){
      return `${Number(value).toLocaleString(locale)} ${type}`;
    }else{
      return Number(value).toLocaleString(locale);
    }
  }
};

export const formatNumber = (number, lang) => {
  if (number < 1000) return number.toString();

  const scaled = number / 1000;
  const formatted = scaled % 1 === 0 ? scaled.toFixed(0) : scaled.toFixed(1);

  return `${localizeValue(formatted, lang.completeCode)}k`;
}


export const horizontalChartTooltipCallBack = (lang, type = null) => {
  return {
    title: (item) => item.formattedValue,
    label: function (context) {
      const value = context.parsed.x;
      const dataset = context.dataset;
      const total = dataset.data.reduce((sum, val) => sum + val, 0);
      const percentage = ((value / total) * 100).toFixed(1);
      if(type){
        return `${localizeValue(value, lang)} ${type}`;
      }else{
        return `${localizeValue(value, lang)} (${localizeValue(percentage, lang)}%)`;
      }
    }
  }
}


export const lineTooltipCallBack = (lang) => {
  return {
    title: (item) => item.formattedValue,
    label: function (context) {
      const value = context.parsed.y;
      const dataset = context.dataset;
      const total = dataset.data.reduce((sum, val) => sum + val, 0);
      const percentage = ((value / total) * 100).toFixed(1);
      return `${localizeValue(value, lang)} (${localizeValue(percentage, lang)}%)`;
    }
  }
}

export const horizontalBarChartJSOptions = (lang, type = null) => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      universalInnerLabel: {
        color: 'white',
        font: 'bold 14px Atkinson-Hyperlegible-Regular',
        formatter: (value) => localizeValue(value, lang.completeCode, type)
      },
      tooltip: {...tooltipChartJSoptions, callbacks: horizontalChartTooltipCallBack(lang.completeCode, type)},
      legend: {
          display: false
      },
      title: {
          display: false
      },
      datalabels: {
          color: 'white',
          anchor: 'center',
          align: 'center',
          formatter: (value) => value,
          font: {
            size: 15,
            weight: 'bold'
          }
      }
    },
    layout: {
      padding: {
        top: 10
      }
    },
    scales: {
      x: {
        display: true,
        beginAtZero: true,
        grid: {
          display: true,
          color: '#ebebebff',
          drawBorder: false
        },
        ticks: {
          display: false
        }
      },
      y: {
        display: false,
        grid: {
          display: true,
          color: '#ebebebff',
          drawBorder: false
        },
        ticks: {
          display: false
        }
      }
    }
  }
};

export const lineChartJSOptions = (lang, maxValue) => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {...tooltipChartJSoptions, callbacks: lineTooltipCallBack(lang.completeCode)},
      legend: {
        display: false
      },
      title: {
        display: false,
      },
      universalInnerLabel: {
        color: '#c75efb',
        font: 'bold 15px Atkinson-Hyperlegible-Regular',
        formatter: (value) => formatNumber(value, lang),
        outlineWidth: 4, 
        outlineColor: "white"
      },
      datalabels: {
        anchor: 'start',
        offset: 8,
        align: 'top',
        formatter: (value) => value,
        font: {
          size: 15
        },
        color: "#000"
      }
    },
    layout: {
      padding: {
        left: 25,
        right: 25,
        top: 25      
      }
    },
    scales:  {
      x: {
        display: true,
        beginAtZero: true,
        grid: {
          display: true,
          color: '#ebebebff',
          drawBorder: true
        },
        ticks: {
          color: "#F54562",
          font: {
            size: 12.5,
            weight: "bold",
            family: "Atkinson-Hyperlegible-Regular"
          }
        }
      },
      y: {
        display: true,
        grid: {
          display: true,
          color: '#ebebebff',
          drawBorder: true
        },
        ticks: {
          display: false
        }
      }
    }
  }
};